module.exports = __webpack_public_path__ + "img/lipaphis-erysimi.4aa215be.jpg";